var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1549,
    height: 644,
    viewBox: "0 0 1549 644",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1444.43 46.7422H93.45C69.8944 46.7422 50.7988 60.4435 50.7988 77.345V553.684C50.7988 570.585 69.8944 584.287 93.45 584.287H1444.43C1467.99 584.287 1487.09 570.585 1487.09 553.684V77.345C1487.09 60.4435 1467.99 46.7422 1444.43 46.7422Z",
    stroke: "#1DA88F",
    strokeOpacity: 0.3,
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1427.6 36.627H76.6199C53.0643 36.627 33.9688 50.3283 33.9688 67.2298V543.569C33.9688 560.47 53.0643 574.171 76.6199 574.171H1427.6C1451.16 574.171 1470.26 560.47 1470.26 543.569V67.2298C1470.26 50.3283 1451.16 36.627 1427.6 36.627Z",
    stroke: "#1DA88F",
    strokeOpacity: 0.3,
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1503.39 122.128H280.636C259.315 122.128 242.031 134.529 242.031 149.827V580.956C242.031 596.254 259.315 608.656 280.636 608.656H1503.39C1524.71 608.656 1542 596.254 1542 580.956V149.827C1542 134.529 1524.71 122.128 1503.39 122.128Z",
    stroke: "#1DA88F",
    strokeOpacity: 0.3,
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.36 141.473H39.6045C18.2838 141.473 1 153.874 1 169.172V600.301C1 615.599 18.2838 628 39.6045 628H1262.36C1283.68 628 1300.97 615.599 1300.97 600.301V169.172C1300.97 153.874 1283.68 141.473 1262.36 141.473Z",
    stroke: "#1DA88F",
    strokeOpacity: 0.3,
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1490.04 21.3574H392.578C373.451 21.3574 357.945 32.4828 357.945 46.2066V433.159C357.945 446.883 373.451 458.009 392.578 458.009H1490.04C1509.17 458.009 1524.67 446.883 1524.67 433.159V46.2066C1524.67 32.4828 1509.17 21.3574 1490.04 21.3574Z",
    stroke: "#1DA88F",
    strokeOpacity: 0.3,
    strokeWidth: 1.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.01 1H57.5523C38.4254 1 22.9199 12.1254 22.9199 25.8492V412.802C22.9199 426.526 38.4254 437.651 57.5523 437.651H1155.01C1174.14 437.651 1189.65 426.526 1189.65 412.802V25.8492C1189.65 12.1254 1174.14 1 1155.01 1Z",
    stroke: "#1DA88F",
    strokeOpacity: 0.3,
    strokeWidth: 1.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1462.81 53.8164H111.821C88.2655 53.8164 69.1699 67.5178 69.1699 84.4192V560.758C69.1699 577.659 88.2655 591.361 111.821 591.361H1462.81C1486.36 591.361 1505.46 577.659 1505.46 560.758V84.4192C1505.46 67.5178 1486.36 53.8164 1462.81 53.8164Z",
    stroke: "#1DA88F",
    strokeOpacity: 0.3,
    strokeWidth: 4.84,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.564 597.257L1455.55 597.257C1479.1 597.257 1498.2 583.555 1498.2 566.654L1498.2 90.3153C1498.2 73.4138 1479.1 59.7125 1455.55 59.7125L104.564 59.7123C81.0081 59.7123 61.9125 73.4137 61.9125 90.3152L61.9125 566.654C61.9125 583.555 81.0081 597.257 104.564 597.257Z",
    stroke: "#05F2C7",
    strokeOpacity: 0.3,
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M121.394 607.373L1472.38 607.373C1495.93 607.373 1515.03 593.672 1515.03 576.77L1515.03 100.431C1515.03 83.53 1495.93 69.8287 1472.38 69.8287L121.394 69.8286C97.8382 69.8286 78.7426 83.5299 78.7426 100.431L78.7426 576.77C78.7426 593.672 97.8381 607.373 121.394 607.373Z",
    stroke: "#05F2C7",
    strokeOpacity: 0.3,
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6045 521.872L1268.36 521.872C1289.68 521.872 1306.97 509.471 1306.97 494.173L1306.97 63.0436C1306.97 47.7457 1289.68 35.3443 1268.36 35.3443L45.6045 35.3442C24.2839 35.3442 7.00004 47.7456 7.00004 63.0435L7 494.173C7 509.471 24.2838 521.872 45.6045 521.872Z",
    stroke: "#05F2C7",
    strokeOpacity: 0.3,
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M286.636 502.527L1509.39 502.527C1530.71 502.527 1548 490.126 1548 474.828L1548 43.6989C1548 28.401 1530.71 15.9996 1509.39 15.9996L286.636 15.9995C265.315 15.9995 248.031 28.4009 248.031 43.6988L248.031 474.828C248.031 490.126 265.315 502.527 286.636 502.527Z",
    stroke: "#05F2C7",
    strokeOpacity: 0.3,
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9597 622.642L1156.42 622.642C1175.55 622.642 1191.05 611.516 1191.05 597.792L1191.05 210.84C1191.05 197.116 1175.55 185.99 1156.42 185.99L58.9598 185.99C39.8328 185.99 24.3273 197.116 24.3273 210.839L24.3273 597.792C24.3273 611.516 39.8328 622.642 58.9597 622.642Z",
    stroke: "#05F2C7",
    strokeOpacity: 0.3,
    strokeWidth: 1.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M393.985 643L1491.45 643C1510.57 643 1526.08 631.875 1526.08 618.151L1526.08 231.198C1526.08 217.474 1510.57 206.349 1491.45 206.349L393.985 206.349C374.858 206.349 359.353 217.474 359.353 231.198L359.353 618.151C359.353 631.875 374.858 643 393.985 643Z",
    stroke: "#05F2C7",
    strokeOpacity: 0.3,
    strokeWidth: 1.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1925 590.183L1437.18 590.184C1460.73 590.184 1479.83 576.482 1479.83 559.581L1479.83 83.242C1479.83 66.3406 1460.73 52.6392 1437.18 52.6392L86.1926 52.6391C62.637 52.6391 43.5412 66.3405 43.5412 83.2419L43.5411 559.581C43.5411 576.482 62.637 590.183 86.1925 590.183Z",
    stroke: "#05F2C7",
    strokeOpacity: 0.3,
    strokeWidth: 4.84,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLines);
export default __webpack_public_path__ + "static/media/backgroundLines.d8d8ec8c2468b651aa903ac5b7b19c9f.svg";
export { ForwardRef as ReactComponent };